import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ThankYouPage = () => {
  const navigate = useNavigate();
  // Destructure orderDetails from the navigation state
  const { 
    orderDetails: orderDetailsData 
  } = useLocation().state || {}; 

  // The price is now expected to be inside the orderDetailsData object (total_price)
  const orderDetails = {
    orderId: orderDetailsData?.order_id,
    invoiceId: orderDetailsData?.invoice_id,
    orderNumber: orderDetailsData?.order_number,
    message: orderDetailsData?.message,
    // ✅ Use the total_price field returned by the API
    totalAmount: orderDetailsData?.total_price || 0, 
  };

  if (!orderDetailsData) {
      return (
          <div className="container py-5 text-center" style={{ minHeight: "80vh", paddingTop: "120px" }}>
              <h2 className="fw-bold mb-3 text-danger">Order Data Missing</h2>
              <p className="text-muted mb-4">It looks like you navigated here directly or the order failed to complete.</p>
              <button
                className="btn btn-dark btn-lg mt-4 w-100"
                onClick={() => navigate("/")}
              >
                Go to Home
              </button>
          </div>
      );
  }

  return (
    <div
      className="d-flex justify-content-center align-items-start"
      style={{ minHeight: "80vh", paddingTop: "120px" }}
    >
      <div className="card shadow p-5 text-center" style={{ maxWidth: "500px", width: "100%" }}>
        
        <h2 className="fw-bold mb-3 text-success">Thank You! 🎉</h2>
        <p className="text-muted mb-4">Your order has been successfully placed.</p>

        <div className="text-start border p-3 rounded-3 bg-light">
          <h5 className="mb-3 border-bottom pb-2">Order Details</h5>
          <p className="mb-1"><strong>Order ID:</strong> {orderDetails.orderId}</p>
          <p className="mb-1"><strong>Invoice ID:</strong> {orderDetails.invoiceId}</p>
          <p className="mb-1"><strong>Order Number:</strong> {orderDetails.orderNumber}</p>
          {orderDetails.message && <p className="mb-1"><strong>Message:</strong> {orderDetails.message}</p>}
          
          <p className="mt-3">
            <strong>Total Amount:</strong> 
            {/* Display the received total amount, using toFixed(2) for formatting */}
            <span className="text-success fw-bold ms-2">₹ {parseFloat(orderDetails.totalAmount).toFixed(2)}</span>
          </p>
        </div>

        <button
          className="btn btn-dark btn-lg mt-4 w-100 rounded-pill"
          onClick={() => navigate("/")}
        >
          Continue Shopping →
        </button>
      </div>
    </div>
  );
};

export default ThankYouPage;